/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useContext } from 'react';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const HeaderSearchbarProvider = (props) => {
    const [state, setState] = useState({});
    return React.createElement(Provider, { value: { state, setState } }, props.children);
};
function useHeaderSearchbar() {
    const HeaderSearchbarContext = useContext(store);
    const showHeaderSearchbar = (searchbar) => {
        HeaderSearchbarContext.setState(Object.assign(Object.assign({}, HeaderSearchbarContext.state), { searchbar: searchbar, show: true }));
    };
    const hideHeaderSearchbar = () => {
        HeaderSearchbarContext.setState(Object.assign(Object.assign({}, HeaderSearchbarContext.state), { show: true }));
    };
    return {
        showHeaderSearchbar: showHeaderSearchbar,
        hideHeaderSearchbar: hideHeaderSearchbar,
        show: HeaderSearchbarContext.state.show,
        searchbar: HeaderSearchbarContext.state.searchbar
    };
}
export { store as HeaderSearchbarStore, HeaderSearchbarProvider, useHeaderSearchbar };
//# sourceMappingURL=index.js.map